const menuOverlayLinks = document.querySelectorAll(".js-menu-overlay-link");

if(menuOverlayLinks) {
    const menuOverlay = document.querySelector(".js-menu-overlay");
    const menuButton = document.querySelector(".js-menu-button");
    const body = document.querySelector("body");

    function menuOverlayScroll() {
        scrollTarget = this.dataset.num;
        let chapter = document.querySelector(`.js-chapter-section-${scrollTarget}`);
        
        closeMenuOverlayAnimations(closeMenuOverlayTl, closeMenuOverlayTl, this);
        menuButton.classList.remove('is-active');
        body.classList.remove('stop-scrolling');
        
        isActive = false;

        gsap.to(window, {
            duration: 0.6,
            ease: "power4.easeInOut",
            scrollTo: chapter
        });
    }
    
    if(menuOverlayLinks) {
        for(var i = 0; i < menuOverlayLinks.length; i++) {
            scrollTarget = menuOverlayLinks[i].dataset.num;
            menuOverlayLinks[i].addEventListener('click', menuOverlayScroll);
        }
    }

    //close menu overlay timeline
    const closeMenuOverlayTl = gsap.timeline({ paused: true });
    closeMenuOverlayTl
        .to(menuOverlay, 0.3, {
            autoAlpha: 0,
            ease: Power1.easeInOut
        });
} 
